import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { GendersFailure, GendersRequest, GendersSuccess } from './actions';
import { GendersService } from './service';
import { AppState } from '@store/app.state';
import { select, Store } from '@ngrx/store';
import { getData } from './selectors';

@Injectable()
export class GendersEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly gendersService = inject(GendersService);

  genders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GendersRequest),
      withLatestFrom(this.store.pipe(select(getData))),
      switchMap(([{ parameters }, data]) => {
        if (!data?.length) {
          return this.gendersService.genders(parameters).pipe(
            map(data => GendersSuccess({ data })),
            catchError(error => of(GendersFailure({ error })))
          );
        }
        return of(GendersSuccess({ data }));
      })
    )
  );

}
